import React from "react";

export const AppContext = React.createContext("app");



// WEBPACK FOOTER //
// ./src/contexts.js